<template>
  <div class="app-container">
    <div class="filter-container">
      <el-date-picker
        v-model="queryPage.ctCreateTime"
        class="filter-item"
        type="datetime"
        placeholder="创建时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        style="width: 200px"
      />
      <el-date-picker
        v-model="queryPage.ctEndTime"
        class="filter-item"
        type="datetime"
        placeholder="结束时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        style="width: 200px"
      />
      <el-input
        v-model="queryPage.patName"
        class="filter-item"
        placeholder="名称"
        style="width: 150px"
        clearable
      />

   
      <el-button class="filter-item" icon="el-icon-search" type="primary" @click="search()">查询</el-button>

      <!-- <el-button icon="el-icon-delete" type="danger" style="float: right" :disabled="sels.length === 0" @click="Delete(sels)">删除</el-button> -->
      <!-- <el-button icon="el-icon-circle-plus-outline" style="float: right" type="primary" @click="handleAdd">新增</el-button> -->
    </div>

    <el-table v-loading="listLoading" :data="tableData" :height="tableHeight4" style="width: 100%; overflow: auto" border @selection-change="selsChange">
      <el-table-column label="序号" type="index" :index="indexMethod" align="center" header-align="center" width="80" />
      <!-- <el-table-column align="center" type="selection" width="55" /> -->
      <el-table-column label="名称" align="left" header-align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.patName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="封面图片" align="left" header-align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <img :src=scope.row.imageAddress width="50px" height="50px">
        </template>
      </el-table-column>
     
      <el-table-column label="所属企业" align="left" header-align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.patCompany }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="right" header-align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.ctCreateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建人" align="left" header-align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.ctCreateUserName }}</span>
        </template>
      </el-table-column>
      <el-table-column header-align="center" fixed="right" align="left" width="200px" label="操作">
        <template slot-scope="scope">
          <!-- <el-button size="small" type="primary" @click="EditNotice(scope.row)">编辑</el-button> -->
          <el-button size="small" type="primary" @click="View(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Pagination
      v-show="total > -1"
      :total="total"
      :page.sync="queryPage.page"
      :limit.sync="queryPage.limit"
      @pagination="loadList"
    />

    <el-dialog
      :visible.sync="menuAddVisible"
      :close-on-click-modal="false"
      
      append-to-body
      width="1000px"
      title="新增"
    >
      <menu-add
        v-if="menuAddVisible"
        ref="menuAdd"
        :proid="code"
        :visible.sync="menuAddVisible"
      />
    </el-dialog>

    <el-dialog
      :visible.sync="menuEditVisible"
      :close-on-click-modal="false"
      
      append-to-body
      width="1000px"
      title="编辑"
    >
      <menu-edit
        v-if="menuEditVisible"
        ref="menuEdit"
        :proid="code"
        :visible.sync="menuEditVisible"
      />
    </el-dialog>

    <el-dialog
      :visible.sync="menuListVisible"
      :close-on-click-modal="false"
      append-to-body
      width="1000px"
      title="详情"
    >
      <menu-list
        v-if="menuListVisible"
        ref="menuList"
        :proid="code"
        :visible.sync="menuListVisible"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getDictListByCode } from '@/api/dict'
import { dropData, getPage } from '@/api/parking'

// import MenuAdd from './add'
// import MenuEdit from './edit'
import MenuList from './view'

import Pagination from '@/components/Pagination'
import { tableHeight4 } from '@/utils/tableHeight'
import { Message } from 'element-ui'

export default {
  components: { Pagination, MenuList },
  mixins: [tableHeight4],
  provide() {
    return {
      getList: this.loadList
    }
  },
  props: {
    keystr: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      types: [],
      sels: [],
      zxList:[],
      itIsdisplayList:[],
      id: '',
      code: '',
      listLoading: false,
      menuAddVisible: false,
      menuEditVisible: false,
      menuListVisible: false,
      tableData: [],
      total: 0,
      queryPage: {
        page: 1,
        limit: 10
      }
    }
  },
  created() {
    this.getDictEntry('YW_RELEASE_TYPE')
    this.getDictEntry('Information_type_ht')
    this.getDictEntry('IS_SHOW'),
    this.loadList()
  },
  methods: {
    getDictEntry(code) {
      getDictListByCode(code).then(response => {
        if (code === 'YW_RELEASE_TYPE') {
          this.types = response.data
        }
        if (code === 'Information_type_ht') {
          
          this.zxList = response.data
        }
        if (code === 'IS_SHOW') {
          
          this.itIsdisplayList = response.data
        }
      })
    },
    getDicName(code, flag) {
      var dict = []
      if (flag === 'YW_RELEASE_TYPE') {
        dict = this.types
      }
      if (flag === 'Information_type_ht') {
        dict = this.zxList
      }
      if (flag === 'IS_SHOW') {
        dict = this.itIsdisplayList
      }
      for (var i in dict) {
        if (dict[i].code === code) {
          return dict[i].name
        }
      }
    },
    search() {
      // 查询
      this.loadList()
    },
    loadList() {
      this.tableData = []
      this.listLoading = true
      getPage(this.queryPage).then((response) => {
        this.tableData = response.data.records
        this.total = parseInt(response.data.total)

        this.listLoading = false
      }).catch((response) => {
        this.listLoading = false
      })
    },
    indexMethod(index) {
      return index + 1 + (this.queryPage.page - 1) * this.queryPage.limit
    },
    handleAdd() {
      this.menuAddVisible = true
      this.$nextTick(() => {
        this.$refs.menuAddVisible
      })
    },
    EditNotice(e) {
      this.menuEditVisible = true
      // this.code = e
      this.$nextTick(() => {
        this.$refs.menuEditVisible
        this.$refs.menuEdit.getDetailed(e)
      })
    },
    View(e) {
      this.menuListVisible = true
      this.code = e
      this.$nextTick(() => {
        this.$refs.menuListVisible
        this.$refs.menuList.getDetailed(e)
      })
    },
    selsChange(sels) {
      this.sels = sels
    },
    Delete() {
      if (this.sels.length === 0) {
        Message({
          message: '至少选择一条数据',
          type: 'error',
          duration: 2 * 1000
        })
        return
      }

      this.$confirm('此操作将删除该停车场信息记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '删除中......',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var ids = this.sels.map((item) => item.id).join()
        dropData({ ids: ids }).then((response) => {
          Message({
            message: '删除成功',
            type: 'success',
            duration: 5 * 1000
          })

          loading.close()
          this.loadList()
        }).catch(response => {
          loading.close()
          this.loadList()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container{
    height:calc(100% - 20px);
    width:calc(100% - 40px);
    padding:10px 20px;
}
#app-contain{
    height:100%;
    width:100%;
}
.filter-container {

  .filter-item {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
    margin-right: 10px;
  }
}
.pagination-container{
    margin-top:0 !important;
    padding: 10px 16px !important;
}
</style>

